export default __webpack_public_path__ + "static/media/id-billing-picturemark-d.ac2e3772.svg";